import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import statusTemplate from '../../../../../templates/workflow/properties/main/form-status.ejs';
import listService  from 'ListService.js';
import Immutable from 'immutable';
import util  from 'util/Util.js';
import constants  from 'Constants.js';

class MainFormStatusView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};
        this.template = statusTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]': 'updateAttributes',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set(propName, propVal);
    }

    showOkStatusMessage(element){
        element.css('background-color', 'white');
        element.html('OK');
    }

    showNoLogicalFlowStatusMessage(element){
        element.css('background-color', '#F57979');
        element.html('No logical flow.');
    }

    validateWorkflowPaths() {

        //PF-4470
        // Check for a path to go back to a default stage.
        let defaultStage = listService._workflow.stages.filter((stage) => {
            return util.isTrue(stage.model.get('isDefault'))
        }).first();

        let element = $("textarea[id='status']");

        // If there is no a default stage.
        if (!defaultStage) {
            this.showNoLogicalFlowStatusMessage(element);
            return;
        }

        // If there are stages without a path
        let areNodesWithoutPaths = listService._workflow.stages.some((stage)=>{
           return stage.model.get('widget').connection.length === 0;
        });

        if(areNodesWithoutPaths){
            this.showNoLogicalFlowStatusMessage(element);
            return;
        }


        // Performing a depth search through whole diagram.
        // Initializing
        listService._workflow.stages.forEach(stage => {
            stage.model.set('visited', '', {silent: true})
        });

        // Search
        let wrongStage = this.performDeepSearch(defaultStage.model.get('id'));
        if(wrongStage!== undefined){
            this.showNoLogicalFlowStatusMessage(element);
            return;
        }

        // If no wrong path found, then show a correct chart structure message.
        this.showOkStatusMessage(element)
    }

    performDeepSearch(nodeId) {
        let currentNode = listService._workflow.stages.get(nodeId);

        // Checking if this one was already evaluated.
        if (currentNode !== null && !util.isTrue(currentNode.model.get('visited'))) {

            // Checking if the paths that the current stage is pointing and being pointed into.
            let pointsToSomething = currentNode.model.get('widget').connection.some((conn) => {
                return conn.end === constants.A_END;
            });
            let isPointedBySomeThing = currentNode.model.get('widget').connection.some((conn) => {
                return conn.end === constants.B_END;
            });

            currentNode.model.set('visited', true, {silent: true});

            // If is the default one just verify, if something is pointing to it in order to break the search.
           if(util.isTrue(currentNode.model.get('isDefault'))){
                if(isPointedBySomeThing){
                    return currentNode.model.get('name')
                }
                   let neighbours = this.getNeighboursByNode(currentNode);

                   for (let i = 0; i < neighbours.length; i++) {
                         let value = this.performDeepSearch(neighbours[i]);
                       if(value !== undefined){
                           return value;
                       }
                   }
               }
            // If not, check if the node is pointing something and is not being pointed in order to stop the search, if not continuing.
            else if (pointsToSomething && !isPointedBySomeThing) {
               return currentNode.model.get('name')
            }
                let neighbours = this.getNeighboursByNode(currentNode);

                for (let i = 0; i < neighbours.length; i++) {
                      let value = this.performDeepSearch(neighbours[i]);
                      if(value !== undefined){
                          return value;
                      }
                }
            }
    }

    getNeighboursByNode(node){
        return node.model.get('widget').connection.reduce((accum, conn) => {
            if (conn.end === constants.A_END) {
                accum.push(conn.line.destId);
            }
            if (conn.end === constants.B_END) {
                accum.push(conn.line.srcId);
            }
            return accum;
        }, []);
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        try{

            let result=listService._workflow;

            let element=$("textarea[id='status']");

            if(result.stages.size===0){
                element.css('background-color','#F57979');
                element.html('No Stages.');
                return this;
            }else if(result.stages.size >0 && result.stages.size === ( result.paths.size +1 )) {
                this.showOkStatusMessage(element);
            }
            else{
                this.showNoLogicalFlowStatusMessage(element);
            }

            if(result.paths) {
                this.validateWorkflowPaths()
            }

        }catch(error){}
        return this;
    }

}

export default MainFormStatusView;
